<template>
  <div class="mb-4">
    <div class="flex items-center">
      <p class="text-dark-blue">
        {{ subject }}
      </p>
      <slot />
    </div>

    <p class="mb-1 text-xxs font-bold uppercase text-gray-over-dark">
      {{ question.description }}
    </p>
    <div class="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-3">
      <div
        v-for="option in orderedOptions"
        :key="option"
        class="mb-2 w-full md:mb-0"
      >
        <radio-button
          :item="option.value"
          :active="selections.includes(option.id)"
          :handle-select="() => handleSelect(option.id)"
          :name="option.id"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RadioButton from '@/components/RadioButton.vue';
import _ from 'lodash';

export default {
  name: 'Checkbox',
  components: {
    RadioButton,
  },
  props: {
    question: Object,
    question_id: Number,
    subject: String,
    setOnboardingPacket: Function,
    toggleRequired: Function,
    required: Boolean,
    conditional_children: Array,
  },
  emits: ['child-check'],
  data() {
    return {
      selections: [],
    };
  },
  computed: {
    orderedOptions() {
      return _.orderBy(this.question.options, 'order');
    },
    stepName() {
      return this.$store.state.formRoutes?.activeStepIdentifier;
    },
  },
  // created() {
  //   let recentAnswer = this.question?.most_recent_previous_answer;
  //   if (recentAnswer) {
  //     this.selections = recentAnswer.answer_options.map(el =>  (el.option_id));
  //     this.handleAutoInput();
  //   }
  // },
  watch: {
    stepName: {
      handler(newVal) {
        if (newVal == 'Questions') {
          let recentAnswer = this.question?.most_recent_previous_answer;
          if (recentAnswer) {
            this.selections = recentAnswer.answer_options.map(
              (el) => el.option_id
            );
            this.handleAutoInput();
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleSelect(id) {
      if (!this.selections.includes(id)) {
        this.selections = [...this.selections, id];
      } else {
        this.selections = this.selections.filter((el) => el !== id);
      }
      let answerOptions = this.selections.map((el) => {
        return { option_id: el };
      });

      if (this.required) {
        this.selections.length
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }

      let body = {
        company_question_id: this.question_id,
        answer_options_attributes: answerOptions,
      };

      this.setOnboardingPacket(body);

      this.emitForComparison(this.selections);
      console.log('this.selections for checkbox');
      console.dir(this.selections);
    },
    handleAutoInput() {
      let answerOptions = this.selections.map((el) => {
        return { option_id: el };
      });

      if (this.required) {
        this.selections.length
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }

      let body = {
        company_question_id: this.question_id,
        answer_options_attributes: answerOptions,
      };
      this.setOnboardingPacket(body);
      this.emitForComparison(this.selections);
    },
    emitForComparison(value) {
      if (this.conditional_children?.length > 0) {
        this.conditional_children.forEach((child) => {
          if (
            child?.evaluation_js?.length > 0 &&
            child?.company_question_id > 0
          ) {
            this.$emit(
              'child-check',
              child.company_question_id,
              value,
              child.evaluation_js,
              child.is_shown_by_default,
              child.is_required
            );
          }
        });
      }
    },
  },
};
</script>
